<template>
  <div style="padding: 20px" class="lang-switcher">
    <div class="flex items-center" :class="locale==='en' ? 'active-lang':'inactive-lang'" @click="setLocale('en')">EN</div>
    <div class="flex items-center ml-2" :class="locale==='bg' ? 'active-lang':'inactive-lang'" @click="setLocale('bg')">BG</div>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'

export default {
  name: 'lang-switch',
  computed: mapState(['locale']),
  methods:{
    ...mapMutations(['setLocale'])
  }
}
</script>

<style lang="scss">
.lang-switcher{
  @apply absolute top-0 right-0 text-xs cursor-pointer flex;
}

.active-lang{
  @apply px-1 rounded bg-neo-500 text-white rounded;
}

.inactive-lang{
  @apply text-neo-500;
}

.inverse{
  .active-lang{
    @apply  text-neo-500 bg-white;
  }

  .inactive-lang{
    @apply text-white;
  }


}

</style>